module.exports = __webpack_public_path__ + "static/img/pic-avatar.0324aba.png";